export default __webpack_public_path__ + "static/short-video-success-stories-6414600890265b791b42258947e10ada.webm";